import trackProductEvent from '../../utils/trackProductEvent';

/**
 * Size guide tracking
 *
 * Tracking events are fired on component render & click event to open the Size
 * guide modal. Size guide is only rendered for brands we have size data for.
 * View events, relative to PDP view events, will give us insight into ratio of
 * user visits that include the Size guide experience.
 *
 * parameters
 * brand: {string}
 * businessLine: {string}
 * skipEventTracking: {boolean} ['Size guide' link view only]
 */

const canonicalName = 'size_guide';

export const trackSizeGuideLinkView = ({
  brand,
  businessLine,
  collectionName,
  skipEventTracking,
  source,
  subSource,
  gated,
}) => {
  if (skipEventTracking) {
    return;
  }

  const eventName = 'size_guide_link_view';
  const actionType = 'view';
  const actionName = 'size_guide_link_view';
  const actionDetail = gated ? 'gated_size_guide' : 'ungated_size_guide';
  const directBuyContext = {
    brand,
    product_business_line: businessLine,
    collection: collectionName,
    source,
    sub_source: subSource,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};

export const trackSizeGuideLinkClick = ({
  brand,
  businessLine,
  collectionName,
  source,
  subSource,
  gated,
}) => {
  const eventName = 'size_guide_link_click';
  const actionType = 'click';
  const actionName = 'size_guide_link_click';
  const actionDetail = gated ? 'gated_size_guide' : 'ungated_size_guide';
  const directBuyContext = {
    brand,
    product_business_line: businessLine,
    collection: collectionName,
    source,
    sub_source: subSource,
  };

  trackProductEvent({
    eventName,
    canonicalName,
    actionType,
    actionName,
    actionDetail,
    directBuyContext,
  });
};
